var _global = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};
_global.SENTRY_RELEASE = {
  id: "e5b743df61dca5c28240629f0fcd2345b364cc82"
};
_global.SENTRY_RELEASES = _global.SENTRY_RELEASES || {};
_global.SENTRY_RELEASES["dubbot-react@dubbot-5f"] = {
  id: "e5b743df61dca5c28240629f0fcd2345b364cc82"
};